/**
 * MIRE legend helpers — wired into `mireConfig.parseLegendLayers`.
 *
 * MIRE has a single Curves layer with no module legend. `MireDataExplorer`
 * is the sole `setFilter` writer for this layer — it merges its own range
 * expression with `mapDataFilterStore.filter` before applying. The MapLayer
 * is therefore marked `excludeFromMapDataFilter` so `syncVisibleLayers`
 * doesn't apply the global filter independently and overwrite the explorer's
 * combined expression.
 */

import { ECurves, EMireModule, type IMireSystemLayers } from './interfaces';
import type { MapLayer } from '#lib/stores/legendStore.svelte.js';

export function parseLegendLayers(payload: IMireSystemLayers): MapLayer[] {
	const feature = payload?.[EMireModule.Curves]?.[ECurves.Curves];
	if (!feature) return [];

	return [
		{
			systemId: feature.id,
			layerId: feature.layer.id as string,
			initialFilter: feature.layer.filter,
			minzoom: feature.layer.minzoom,
			filterAttr: '',
			legendItems: [],
			layerAllEnabled: true,
			layerAnyEnabled: true,
			// Explorer is the sole setFilter writer and merges the global
			// mapDataFilter into its expression — opt out here.
			excludeFromMapDataFilter: true
		}
	];
}
